import { type ButtonHTMLAttributes, forwardRef } from 'react'

import { themeHoverTextColorMap } from '@mntn-dev/ui-theme'
import { cn } from '@mntn-dev/ui-utilities'

import { Icon, type IconProps } from '../icon/icon.tsx'
import type { IconHoverColor } from '../icon/types/core.ts'

type IconButtonProps = IconProps &
  Readonly<
    Pick<ButtonHTMLAttributes<HTMLButtonElement>, 'onClick'> & {
      hoverColor?: IconHoverColor
      centered?: boolean
      className?: string
    }
  >

const IconButton = forwardRef<SVGSVGElement, IconButtonProps>(
  ({ hoverColor, centered, className, ...iconProps }, ref) => {
    return (
      <Icon
        {...iconProps}
        tabIndex={0}
        role="button"
        className={cn(
          iconProps.disabled ? 'cursor-not-allowed' : 'cursor-pointer',
          hoverColor && !iconProps.disabled
            ? `${themeHoverTextColorMap[hoverColor]} transition-colors`
            : null,
          centered ? 'self-center' : null,
          className
        )}
        ref={ref}
      />
    )
  }
)

export { IconButton, type IconButtonProps }
